document.addEventListener('DOMContentLoaded', function () {
  function pad(n) { return String(n).padStart(2, '0'); }
  function fmt(d) { return pad(d.getDate()) + '/' + pad(d.getMonth() + 1); }

  document.querySelectorAll('.di-date-start').forEach(function (startEl) {
    var wrap = startEl.closest('.delivery-text');
    var endEl = wrap ? wrap.querySelector('.di-date-end') : null;
    if (!endEl) return;
    var today = new Date();
    var start = new Date(today); start.setDate(start.getDate() + 18);
    var end = new Date(today); end.setDate(end.getDate() + 24);
    startEl.textContent = fmt(start);
    endEl.textContent = fmt(end);
  });

  /* Delegated (not queried-once) so triggers/overlays added later — e.g. the
     "Learn more" buttons in the "Our Premium Quality" carousel, which live
     in a different section and can be re-rendered by the theme editor —
     open and close correctly without needing their own copy of this
     wiring. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-help-target]');
    if (trigger) {
      var overlay = document.getElementById(trigger.getAttribute('data-help-target'));
      if (overlay) {
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
      }
      return;
    }

    var closeBtn = e.target.closest('.help-modal-close');
    if (closeBtn) {
      var overlayToClose = closeBtn.closest('.help-modal-overlay');
      if (overlayToClose) {
        overlayToClose.classList.remove('is-open');
        overlayToClose.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    if (e.target.classList && e.target.classList.contains('help-modal-overlay')) {
      e.target.classList.remove('is-open');
      e.target.setAttribute('aria-hidden', 'true');
    }
  });
});
